import axios from "axios";
import configuration from "@/services/configuration";
import apiClient from "./axiosConfig";

// Mantém a instância original para compatibilidade
const api = axios.create({
  baseURL: configuration.api.url,
  responseType: "json",
});

// Acessa as variáveis de ambiente a partir de import.meta.env
if (import.meta.env !== "test") {
  api.defaults.timeout = 600000; // 10 minutos para timeout
}

if (import.meta.env === "development") {
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
}

// Exporta a instância original para compatibilidade e a nova com interceptadores
export default api;
export { apiClient };
